const lenisScrollListeners = [];

export function initLocomotive(Scroll) {
  if (!Scroll) return null;

  const loco = new Scroll({
    lenisOptions: {
      lerp: 0.08,
      duration: 1.2,
      smoothWheel: true,
    },
    autoStart: true,
    scrollCallback: () => {
      lenisScrollListeners.forEach((fn) => fn());
    },
  });

  loco.subscribeLenisScroll = (fn) => {
    if (typeof fn === "function") lenisScrollListeners.push(fn);
  };

  /** Recalculate scroll bounds after layout changes (accordion / slider). */
  loco.bump = (delayMs = 0) => {
    if (typeof loco.update !== "function") return;
    loco.update();
    requestAnimationFrame(() => loco.update());
    if (delayMs > 0) setTimeout(() => loco.update(), delayMs);
  };

  if (typeof loco.start === "function") loco.start();

  return loco;
}
